/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutopaySourceDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import BankAccount from './BankAccount/index'
import CreditCard from './CreditCard/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AutopaySourceDetails({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/ChooseAutopaySource/Content/AutopaySourceDetails"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentsEditAutopayAutopaySourceIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_edit_autopay',
path: 'autopay_source_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentsEditAutopayAutopaySourceIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreditCard'}>
<CreditCard
  viewPath={`${viewPath}/CreditCard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BankAccount'}>
<BankAccount
  viewPath={`${viewPath}/BankAccount`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}